/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Grid, Typography, withStyles } from '@material-ui/core';
import { CustomTextField, getErrorMessage } from './index';

const CustomTypography = withStyles({
  root: {
    color: '#333333',
    marginBottom: 8
  }
})(Typography);

const ModalEditTestIBM = ({ formValue, setFormValue, errors }) => {
  const onChangeTestValue = (name, value = '') => {
    if (!value) setFormValue(prevState => ({ ...prevState, [name]: '' }));
    // Regex test number contain decimal. Maximum length number of decimal is 9
    const regexNumber = /^(\d+\.?\d{0,9}|\.\d{1,9})$/g;
    if (regexNumber.test(value)) {
      setFormValue(prevState => ({ ...prevState, [name]: value }));
    }
  };

  return (
    <>
      <Grid item xs={6}>
        <CustomTypography variant="subtitle2">BMI Height (m)</CustomTypography>
        <CustomTextField
          size="small"
          fullWidth
          value={formValue.height}
          required
          placeholder="Example: 1.62"
          variant="outlined"
          type="number"
          onChange={e => onChangeTestValue('height', e.target.value)}
          error={!!errors.height}
          helperText={getErrorMessage(errors.height)}
        />
      </Grid>
      <Grid item xs={6}>
        <CustomTypography variant="subtitle2">BMI Weight (kg)</CustomTypography>
        <CustomTextField
          size="small"
          fullWidth
          value={formValue.weight}
          required
          placeholder="Example: 49"
          variant="outlined"
          type="number"
          onChange={e => onChangeTestValue('weight', e.target.value)}
          error={!!errors.weight}
          helperText={getErrorMessage(errors.weight)}
        />
      </Grid>
    </>
  );
};

export default ModalEditTestIBM;
